import api from './api';

// Transform snake_case to camelCase
const transformTask = (task) => ({
  id: task.id,
  weddingId: task.wedding_id,
  organizationId: task.organization_id,
  title: task.title,
  description: task.description,
  dueDate: task.due_date,
  priority: task.priority,
  status: task.status,
  assignedTo: task.assigned_to,
  assignedToName: task.assigned_to_name,
  eventId: task.event_id,
  notes: task.notes,
  createdAt: task.created_at,
  updatedAt: task.updated_at
});

// Transform camelCase to snake_case
// IMPORTANT: Only include due_date if it is explicitly provided.
// This prevents unintended overwrites (e.g. drag/drop status updates).
const transformTaskToSnakeCase = (task) => {
  const payload = {
    title: task.title,
    description: task.description,
    priority: task.priority,
    status: task.status,
    assigned_to: task.assignedTo,
    event_id: task.eventId || null,
    // assigned_to_name is not sent to backend, only stored in frontend state
    notes: task.notes,
  };

  if (task.dueDate) {
    payload.due_date = task.dueDate;
  }

  return payload;
};

export const taskService = {
  async getTasks(weddingId, organizationId) {
    const response = await api.get(`/api/tasks?wedding_id=${weddingId}&organization_id=${organizationId}`);
    return response.data.map(transformTask);
  },

  async getTask(taskId) {
    const response = await api.get(`/api/tasks/${taskId}`);
    return transformTask(response.data);
  },

  async createTask(weddingId, organizationId, taskData) {
    const payload = transformTaskToSnakeCase(taskData);
    const response = await api.post(`/api/tasks?wedding_id=${weddingId}&organization_id=${organizationId}`, payload);
    return transformTask(response.data);
  },

  async updateTask(taskId, taskData) {
    const payload = transformTaskToSnakeCase(taskData);
    const response = await api.put(`/api/tasks/${taskId}`, payload);
    return transformTask(response.data);
  },

  async deleteTask(taskId) {
    const response = await api.delete(`/api/tasks/${taskId}`);
    return response.data;
  }
};
